import destinationMarker from '@/assets/icons/map/route-locations/destination.svg?url';
import originMarker from '@/assets/icons/map/route-locations/origin.svg?url';
import { RouteLocationType } from '@/types/RouteLocationType';

interface RouteLocationMarkerImageProps {
  markerType: RouteLocationType;
}

export function RouteLocationMarkerImage({ markerType }: RouteLocationMarkerImageProps) {
  return (
    <img
      alt=""
      src={{ [RouteLocationType.ORIGIN]: originMarker, [RouteLocationType.DESTINATION]: destinationMarker }[markerType]}
    />
  );
}
